import App from './App'
import { WIDGET_NAME } from './constants';

if (!customElements.get(WIDGET_NAME)) {
  customElements.define(WIDGET_NAME, App);
}
